function collapseSection(element) {
    element.style.height = 0;
}

function expandSection(element) {
    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + "px";
}

export function toggleCollapsible(element) {
    var isExpanded = element.classList.contains('expanded');

    if (isExpanded) {
        collapseSection(element);
    } else {
        expandSection(element);
    }
    element.classList.toggle('expanded');
}
